import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {useSelector} from "react-redux";
import {routes} from "../Constants";


const PublicRoutes = (props) => {
    const isAuth = useSelector(state => state.auth.isAuth);

    return (isAuth ? <Redirect to={routes.App.Home}/> : <Route {...props}>{props.children}</Route>);
};

export default PublicRoutes;